import Hero from "../components/home/Hero";
import NetworksGrid from "../components/home/NetworksGrid";
import HowItWorks from "../components/home/HowItWorks";
import TrustStats from "../components/home/TrustStats";
import Testimonials from "../components/home/Testimonials";
import SEOHead from "../components/SEOHead";
import { useLanguage } from "../contexts/LanguageContext";

export default function Home() {
  const { t } = useLanguage();
  return (
    <div data-testid="home-page">
      <SEOHead
        title={t("seo.home_title", "Buy Likes and Followers | Get Instagram, TikTok & YouTube Growth")}
        description={t("seo.home_description", "Buy Likes and Followers from a trusted social media growth platform. Grow Instagram, TikTok, YouTube and more with fast and secure services.")}
        schema={{ "@context": "https://schema.org", "@type": "Organization", "name": "Buy Likes and Followers" }}
      />
      <Hero />
      <NetworksGrid />
      <HowItWorks />
      <TrustStats />
      <Testimonials />
    </div>
  );
}
